// Közös választéklisták a NAPLO naplófőkönyvhöz.
export const NAPLO_OPCIOK = {
  // A naplófőkönyv 7 fő oszlopa (követelés/kötelezettség oszlopokon kívül).
  fooszlopok: [
    { value: 1, label: '1 – Értékesítés árbevétele', irany: 'bevetel' },
    { value: 2, label: '2 – Egyéb, eredményt nem képező bevételek', irany: 'bevetel' },
    { value: 3, label: '3 – Anyag, árubeszerzés', irany: 'kiadas' },
    { value: 4, label: '4 – Munkabér', irany: 'kiadas' },
    { value: 5, label: '5 – Munkabér közterhei', irany: 'kiadas' },
    { value: 6, label: '6 – Egyéb ráfordítások', irany: 'kiadas' },
    { value: 7, label: '7 – Egyéb eredménybe nem számító kiadások', irany: 'kiadas' },
  ],
  rovatTipus: [
    { value: 'rovat', label: 'Rovat' },
    { value: 'atvezetes', label: 'Átvezetés (X…)' },
    { value: 'kov_kotel', label: 'Követelés/Kötelezettség' },
  ],
  oszlopTipus: [
    { value: 'kovetel', label: 'Követelés' },
    { value: 'kotelez', label: 'Kötelezettség' },
  ],
  penztarTipus: [
    { value: 'penztar', label: 'Pénztár' },
    { value: 'bank', label: 'Bank' },
  ],
  irany: [
    { value: 'bevetel', label: 'Bevétel' },
    { value: 'kiadas', label: 'Kiadás' },
  ],
  kiegyTipus: [
    { value: 'vevo', label: 'Vevő (kimenő)' },
    { value: 'szallito', label: 'Szállító (bejövő)' },
  ],
  // Gyakori magyar áfa-kulcsok (a 0 = áfamentes/tárgyi mentes tételekhez).
  afaKulcsok: [0, 5, 18, 27],
};

export function bevetelOszlop(oszlop: number): boolean {
  return oszlop === 1 || oszlop === 2;
}
